import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class configCategoriesView_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `

                <div class="w-form w-form-large">
                
                    <div class="form-header">
                        <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                        <h3 class="form-title">Config Categories</h3>
                        <div>
                            <button data-bind="event: { click: onClickEdit }" class="btn icon i-edit" type="button">Edit Category</button> 
                        </div>
                    </div>
                    
                    <div class="w-form-body">
                        
                        <div class="form-body">
                 

                            <div class="form-group">
                                <dl class="double-list">
                                    <dt>
                                        <span>Available for use</span>
                                    </dt>
                                    <dd>
                                        <span style="text-transform: none"  data-bind="text: isSelectable"></span>
                                    </dd> 
                                    <dt>
                                        <span>Name</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: name"></span>
                                    </dd>
                                    
                                    <dt>
                                        <span>Date Created</span>
                                    </dt>
                                    <dd>
                                        <span style="text-transform: none"  data-bind="text: dateCreated"></span>
                                    </dd> 
                                 </dl>
                            </div>
                        </div>
                        
                        <strong class="form-sub-title">Image</strong>
                        <div class="form-group">
                            <!-- ko if: image() != null  -->
                            <img data-bind="attr: { src: image() != null ? image().url : '' }"  alt="No Image" style="width: 50%;"  src=""/>
                            <!-- /ko -->
                            <!-- ko if: image() == null  -->
                            <span>No Image</span>
                             <!-- /ko -->
                        </div>
                        <strong class="form-sub-title">Icon</strong>
                        <div class="form-group" >
                             <!-- ko if: icon() != null -->
                            <img data-bind="attr: { src: icon() != null ? icon().url : '' }"  alt="No Image" style="width: 50%;"  src=""/>
                            <!-- /ko -->
                            <!-- ko if: icon() == null -->
                            <span>No Icon</span>
                            <!-- /ko -->
                        </div>
                        <!-- second row -->
                        <div class="form-body">    
                                           
                        </div> 
                    </div>
                        
                `;
    }

    protected initPartial(): void{

    }

    protected getTemplateName(): string{

        return "configCategoriesView_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
            id: ko.observable("")
            , name: ko.observable("")
            , slug: ko.observable("")
            , description: ko.observable("")
            , isSelectable: ko.observable("")
            , dateCreated: ko.observable("")
            , pinnedTags : ko.observableArray([])
            , image : ko.observableArray(null)
            , icon : ko.observableArray(null)
            , onClickEdit: function (data,  event){
                huit_neuf_this.onClickEdit(data.id());
            }
            , onClickCancel: function (data, event){
                huit_neuf_this.onClickCancel();
            }
        }
    };

    public onClickEdit(id){

        this.caller.edit(id);
    }

    public onClickCancel(){

        this.caller.cancel();
    }

    public setId(id): void{

        this.getTemplateViewModel().id(id);
    }

    public setName(name): void{

        this.getTemplateViewModel().name(name);
    }

    public setSlug(name): void{

        this.getTemplateViewModel().slug(name);
    }

    public setDescription(description): void{

        this.getTemplateViewModel().description(description);
    }

    public setIsSelectable(isSelectable): void{

        this.getTemplateViewModel().isSelectable(isSelectable);
    }

    public setDateCreated(dateCreated): void{

        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setPinnedTags(pinnedTags): void{

        this.getTemplateViewModel().pinnedTags(pinnedTags)
    }

    setImage(image: any) {
        this.getTemplateViewModel().image(image)
    }

    setIcon(icon: any) {
        this.getTemplateViewModel().icon(icon)
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/configCategoriesView_template.ts